<template>
    <div v-if="+this.status === 200" class="py-3 d-flex flex-column gap-3">
        <PageHeader title="Training"
                    backeUrl="user-trainings"
                    :isEventEnded="isTrainingEnded"
                    :isEventTimeOut="isTrainingTimeOut"
                    :template="this.template"
                    :userAnswers="this.userAnswers"/>

        <div v-if="!isTrainingEnded" class="tabContent">
            <PageInformation @eventTimeout="onTrainingTimeout"
                             @eventEnded="onTrainingEnded"
                             type="training"
                             backeUrl="user-trainings"
                             :trainingType="trainingType"
                             :startDate="this.startDate"
                             :endDate="this.endDate"
                             :endTime="this.endTime"
                             :started_at="this.started_at"
                             :startTime="this.startTime"
                             :duration="this.duration"
                             :is_submited="this.isSubmited"
                             :is_user_submit="this.isUserSubmit"
            />
            <Questions :template="this.template" :userAnswers="this.userAnswers"/>
        </div>
        <div v-else>
            <p class="text-center">Training has Ended</p>
        </div>
    </div>

    <AlartModal v-if="showErrorModal" :message="responseErrorMessage" imagePath="close.png"
                @close-modal="showErrorModal = false"/>
</template>

<script>
    import PageHeader from "../commonCoponents/pageHeader";
    import PageInformation from "../commonCoponents/pageInformation";
    import Questions from "../commonCoponents/questions";
    import getQuestionType from "../../../../helpers/getQuestionType";
    import training from "../../../../api-services/training";
    import {defineAsyncComponent} from "vue";
    import competition from "../../../../api-services/competition";

    const AlartModal = defineAsyncComponent(() =>
        import ('../../../components/AlartModal')
    );

    export default {
        name: 'answer-competition',
        components: {PageHeader, PageInformation, Questions, AlartModal},
        data() {
            return {
                id: this.$route.params.id,
                trainingType: null,
                isTrainingEnded: false,
                isTrainingTimeOut: false,
                showErrorModal: false,
                duration: null,
                startTime: null,
                endDate: null,
                started_at: null,
                isSubmited: false,
                isUserSubmit: false,
                submitFlag: false,
                status: null,
                startDate: null,
                responseErrorMessage: '',
                data: {
                    questions: [],
                    userAnswers:[],
                    userAnswerSlides:[],
                },
                userAnswers: {
                    competition_training_id: this.$route.params.id,
                    answers: [],
                    slides: []
                },
                template: {
                    competition_training_id: this.$route.params.id,
                    steps: 0,
                    viewCounter: 1,
                    trueOrFalse: [],
                    multipleChoices: [],
                    freeText: [],
                    slides: [],
                    rank: [],
                    arrange: [],
                    changeFlag: false
                },
                keys: ['trueOrFalse', 'multipleChoices', 'freeText', 'slides', 'rank', 'arrange']
            }
        },
        async mounted() {

            console.log('start...')
            await this.$store.dispatch('activeTap', 'training');

            // const response = await training.show(this.$route.params.id);
            const response = await training.start(this.$route.params.id);
            console.log({response})
            console.log(response.data.data)

            this.data.questions = response.data.data.template.questions;
            this.data.userAnswers = response.data.data.userAnswers;
            this.data.userAnswerSlides = response.data.data.userAnswerSlides;
            this.template.slides = response.data.data.template.slides  ? response.data.data.template.slides : [];
            this.startDate = response.data.data.start_date;
            this.endDate = response.data.data.end_date;
            this.startTime = response.data.data.start_time;
            this.endTime = response.data.data.end_time;
            this.duration = response.data.data.duration;
            this.started_at = response.data.data.started_at;
            this.isSubmited = response.data.data.is_submited;
            this.isUserSubmit = response.data.data.is_user_submit;

            this.trainingType = response.data.data.training_type;

            console.log(this.trainingType)

            let type = null;
            this.data.questions.forEach((item) => {
                type = getQuestionType(item['type']);
                this.template[type].push(item);
            });

            this.data.userAnswers.forEach((item) => {
                this.userAnswers[item['type']].push(item);
            });

            if( this.data.userAnswerSlides.length > 0){
                this.template.slides[0].categories.forEach((cat) => {
                    cat.slide_categories.forEach((item, index) => {
                        this.data.userAnswerSlides.forEach((slide, idx) => {
                            if (((slide.category_id === item.category_id) && (slide.order === index+1) && (slide.competition_training_id === +this.id))){
                                item.path = slide.path;
                                console.log({slide})
                                this.userAnswers['slides'].push(slide);
                            }
                        })
                    })
                })
            }

            this.status = response.status;

            this.keys.forEach((key) => {
                if(this.template[key].length > 0){
                    this.template.steps += 1;
                }
            })
            console.log('ssss ',  +this.status === 200 )
            console.log('this.template ==>> ', this.template)

        },
        methods: {
            onTrainingEnded() {
                this.isTrainingEnded = true;
            },
            onTrainingTimeout(){
                this.isTrainingTimeOut = true;
            }
        }
    }
</script>

<style scoped>
    .tabContent {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 30px;
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
        border-radius: 20px;
    }
</style>